export enum AppPermissions {
  CanEditSites = 'Can edit sites',
  CanEditAccounts = 'Can edit accounts',
  CanControlDevices = 'Can remotely control devices',
  CanBulkControlDevices = 'Can bulk control devices',
  CanGenerateFleetReport = 'Can generate fleet report',
  CanEditLoggerMode = 'Can edit logger mode',
  CanAmendThreshold = 'Can amend threshold',
  CanEditCorrelations = 'Can edit correlations',
  CanEditLeakConfirmations = 'Can edit leak confirmations',
  CanViewDeviceRecordings = 'Can view device recordings',
  CanEditLastNote = 'Can edit last note',
  CanCreateExtendedRecordings = 'Can create extended recordings',
  CanSeeImports = 'Can see imports',
  CanSetAudioFilter = 'Can set audio filter',
  CanRecycleSites = 'Can recycle sites',
  CanDeleteAccount = 'Can delete account',
  CanSeeAnyAccount = 'Can see any account',
  CanSeeMaintenanceTab = 'Can view maintenance',
  CanUseExtendedRepeatForSoundRecording = 'Can use extended repeat for sound recording',
  CanEditAnalystReport = 'Can edit Analyst Report',
  CanLinkAccounts = 'Can Link Accounts',
  CanSeeFlowData = 'Can see flow data',
  CanUseFunctionsBulkActions = 'Can use functions bulk actions',
  CanManageMLAnalysis = 'Can manage ML Analysis',
}

export enum AppFeatureFlags {
  ThresholdModelling = 'ThresholdModeling',
  NewLeaks = 'NewLeaks',
  LeakAnalysis = 'AnalystReport',
  SiteNoteBulkUpload = 'SiteNoteBulkUpload',
  JobPack = 'JobPack',
  MonitoredSites = 'MonitoredSites',
  ElectricalNoiseIdentification = 'ElectricalNoiseIdentification',
  MLAudioAnalysis = 'MLAudioAnalysis',
  MicrostreamSurveys = 'MicrostreamSurveys',
  ECLData = 'ECLData',
}
